export type IdentityGate = (action: () => void) => void;
export const RUN_NOW: IdentityGate = (action) => action();
